import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { FED_ISSUER } from '~/auth/providers/fed.provider';
import { AuthService } from '~/auth/services/auth/auth.service';
import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';
import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { BreakpointWidthEnum } from '~/core/enums/breakpoint-width.enum';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';

@Component({
  selector: 'app-organizer-fed-landing-page',
  templateUrl: './fed-landing-page.component.html',
  styleUrls: ['./fed-landing-page.component.scss'],
})
export class OrganizerFedLandingPageComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  public readonly iconType = VtmnPlayIconTypeEnum;
  public readonly logoType = LogoTypeEnum;
  public readonly mdScreenSize = `(min-width:${BreakpointWidthEnum.MD}px)`;
  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;

  private isMobileDevice: boolean;

  constructor(
    @Inject(FED_ISSUER) private readonly fedIssuer: string,
    private readonly matchMediaService: MatchMediaService,
    private readonly authService: AuthService,
    private readonly translateService: TranslateService,
    private readonly localizeRouterService: LocalizeRouterService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public get buttonSize(): VtmnPlayButtonSizeEnum {
    return this.isMobileDevice
      ? this.vtmnPlayButtonSize.SMALL
      : this.vtmnPlayButtonSize.MEDIUM;
  }

  public FEDLogin(): void {
    this.authService.login(this.fedIssuer, {
      from: this.localizeRouterService
        .translateRoute('/organizer.planning.planning')
        .toString(),
      lang: this.translateService.currentLang,
    });
  }
}
